import { useEffect, useLayoutEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Button } from './inputs/Button';
import styles from './ReadMore.module.scss';
function useOffsetHeight(content, children) {
  const [height, setHeight] = useState(null);
  useLayoutEffect(() => {
    function updateSize() {
      if (content && content.current) {
        setHeight(content.current.offsetHeight);
      }
    }
    window.addEventListener('resize', updateSize);
    updateSize();
    return () => window.removeEventListener('resize', updateSize);
  }, [content, children]);
  return height;
}

const ReadMore = ({
  children,
  height,
  expandWord = 'Read',
  collapsedHeight = 200,
  classes = {},
  className,
  btnColor,
  openDefault = false,
}) => {
  const content = useRef(null);
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const contentHeight = useOffsetHeight(content, children);
  const [open, setOpen] = useState(openDefault);
  const button = useRef(null);

  const handleFocusIn = (e) => {
    // automatically expand if a hidden link is selected
    if (document.activeElement.offsetTop >= height - 50 && content?.current?.contains(document.activeElement) && !open) {
      setOpen(true);
    }
  };

  useEffect(() => {
    if (!isSmallEnough) {
      document.addEventListener('focusin', handleFocusIn);
      return () => {
        document.removeEventListener('focusin', handleFocusIn);
      };
    }
  }, []);

  const isSmallEnough = contentHeight !== null ? contentHeight < collapsedHeight : false;
  const divHeight = open || isSmallEnough ? { maxHeight: contentHeight + 100 } : height ? { maxHeight: height } : {};
  return (
    <div className={classNames(styles['see-more'], className)}>
      <div
        className={classNames(styles['see-more-content-wrapper'], classes.contentWrapper, {
          [styles['see-more-content-wrapper--open']]: open || isSmallEnough,
        })}
        style={divHeight}
      >
        <div
          className={classNames(styles['see-more-content-overlay'], classes.overlay, {
            [styles['see-more-content-overlay--open']]: open || isSmallEnough,
          })}
        ></div>
        <div className={classNames(styles['see-more-content'], classes.content)} ref={content}>
          {children}
        </div>
      </div>
      {!isSmallEnough && (
        <div className={styles['see-more-button-wrapper']}>
          <Button
            ref={button}
            onClick={() => {
              button.current.blur();
              setOpen(!open);
            }}
            label={`${expandWord} ${open ? 'Less' : 'More'}`}
            type="thin"
            color={btnColor || 'light-blue'}
          />
        </div>
      )}
    </div>
  );
};
ReadMore.propTypes = {
  children: PropTypes.any,
  height: PropTypes.number,
  expandWord: PropTypes.string,
  className: PropTypes.string,
  collapsedHeight: PropTypes.number,
  openDefault: PropTypes.bool,
  classes: PropTypes.shape({
    content: PropTypes.string,
    overlay: PropTypes.string,
    contentWrapper: PropTypes.string,
  }),
};

export { ReadMore as default, ReadMore };
